<script lang="ts">
    import { Card, Col, Image } from "sveltestrap";
    import { details2 } from "../../../utils/Constant/Constant";
    let imgPath:string = "/assets/images/blog"
</script>
<Col xl="6" class="box-col-6 search-banner">
  <Card>
    <div class="blog-box blog-shadow">
      <Image fluid src="{imgPath}/blog.jpg" alt=""/>
      <div class="blog-details">
        <p class="digits">{'25 July 2018'}</p>
        <h4>{details2}</h4>
        <ul class="blog-social digits">
          <li><i class="icofont icofont-user"></i>{'Mark Jecno'}</li>
          <li><i class="icofont icofont-thumbs-up"></i>{'02 Hits'}</li>
        </ul>
      </div>
    </div>
  </Card>
</Col>